import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import './index.css';
import AdPage from './AdPage';
import MainPage from './pages/MainPage';
import {IntlProvider} from 'react-intl';
import getLanguageSet from './internationalization/language';
import Privacy from './pages/privacy';
import Footer from './pages/Footer';
import Imprint from './pages/Imprint';
import Contact from './pages/Contact';

const root = ReactDOM.createRoot(document.getElementById('root'));
const locale = navigator.language;
let lang = getLanguageSet(locale)

root.render(
  <React.StrictMode>
    <IntlProvider locale ={locale} messages={lang}>
      <BrowserRouter>
        <Routes>
          <Route path='/ad' element={<AdPage />}/>
          <Route path='/contact' element={<><Contact /><Footer/></>} />
          <Route path='/imprint' element={<><Imprint /><Footer/></>} />
          <Route path='/privacy' element={<><Privacy language={locale} /> <Footer/></>} />
          <Route path='/supportedos' element={<><MainPage initial={1}/><Footer/></>} />
          <Route path='/mainfeatures' element={<><MainPage initial={2}/><Footer/></>} />
          <Route path='/freevspro' element={<><MainPage initial={3}/><Footer/></>} />
          <Route path='/sync' element={<><MainPage initial={4}/><Footer/></>} />
          <Route path='/languages' element={<><MainPage initial={5}/><Footer/></>} />
          <Route path='/privacysummary' element={<><MainPage initial={6}/><Footer/></>} />
          <Route path='/downloads' element={<><MainPage initial={7}/><Footer/></>} />
          <Route path='/*' element={<><MainPage /><Footer/></>} />
        </Routes>
      </BrowserRouter>
    </IntlProvider>
  </React.StrictMode>
);
